export const RouteEnum = {
	HOME: "/",

	//Authentication
	LOGIN: "/login",
	FORGOT_PASSWORD: "/forgot-password",
	SIGN_UP: "/sign-up",
	LOGOUT: "/logout",
	RESET_PASSWORD: "/reset-password",
	OTP: "/otp",
	RECOVER_ACCOUNT: '/recover-account',


	DASHBOARD: "/dashboard",

	//ADMIN
	ADMIN_USER_CONTROL: '/admin-users',
	ADMIN_USER_DETAILS: '/admin-user-details',

	//COMPANY
	COMPANIES: "/company",
	COMPANY_USERS: "/company-users",
	COMPANY_DETAILS: "/company-details",	

	//LICENSE
	LICENSES: "/licenses",
	BUY_LICENSE: "/buy-license",
	BUY_LICENSE_PACKAGE: "/buy-license-package",
	GENERATE_LICENSE: "/generate-license",
	LICENSE_DETAILS: '/license-details',

	//LICENSE
	INSTANCE_MANAGEMENT: "/instance-management",
	INSTANCE_MANAGEMENT_DETAILS: '/instance-management-details',

	//BILLING
	BILLINGS: '/billing',
	BILLING_DETAILS: '/billing-details',

	//MAINTENANCE
	MAINTENANCE: '/maintenance',
	ACCESSIBILITIES: "/accessibilities",
	ACCESSIBILITY_DETAILS: "/accessibility-details",	
	MODULE_SETTING: '/module-settings',
	PRICE_SETTING: '/price-settings',
	VENDORS: '/vendors',
	REGISTRATION_CODES: '/registration-codes',

	//MY PROFILE
	MY_PROFILE: '/my-profile',
};
